import { AgxButton, AgxSpacer, AgxTypography, Icon_Arrow } from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import { useNavigate } from 'react-router-dom';
import TaskProgressorConfirmationModal from './TaskProgressorConfirmationModal';
import TaskProgressorSelectors from './TaskProgressorSelectors';
import TaskProgressorWorkflow from './TaskProgressorWorkflow';
import useTaskProgressor from './useTaskProgressor';

const TaskProgressor = () => {
  const navigate = useNavigate();
  const progressor = useTaskProgressor();

  return (
    <AgxSpacer gap="spacing-xl" fill>
      <AgxSpacer direction="horizontal" gap="spacing-md" contentAlignment="center">
        <AgxButton
          id="task-progressor-back"
          text="Support"
          variant="hollow"
          size="small"
          leftIcon={<Icon_Arrow direction="left" width={16} height={16} />}
          onClick={() => navigate(`/${Pages.SUPPORT}`)}
        />
      </AgxSpacer>

      <AgxSpacer gap="spacing-2xl" fill>
        <AgxSpacer gap="spacing-xs">
          <AgxTypography id="task-progressor-title" type="title" size="large">
            Task Progressor
          </AgxTypography>
          <AgxTypography id="task-progressor-subtitle" type="body" size="small">
            Staff workflow task progression
          </AgxTypography>
        </AgxSpacer>

        <TaskProgressorSelectors
          agencyOptions={progressor.agencyOptions}
          campaignOptions={progressor.campaignOptions}
          selectedAgencyId={progressor.selectedAgencyId}
          selectedCampaignId={progressor.selectedCampaignId}
          isLoadingAgencies={progressor.isLoadingAgencies}
          isLoadingCampaigns={progressor.isLoadingCampaigns}
          isLoadingCampaignDetails={progressor.isLoadingCampaignDetails}
          hasLoadError={progressor.hasLoadError}
          isPending={progressor.isPending}
          onAgencyChange={progressor.onAgencyChange}
          onCampaignChange={progressor.onCampaignChange}
        />

        {progressor.campaignDetails && (
          <TaskProgressorWorkflow
            campaignDetails={progressor.campaignDetails}
            selectedContract={progressor.selectedContract}
            contractOptions={progressor.contractOptions}
            stageOptions={progressor.stageOptions}
            selectedContractId={progressor.selectedContractId}
            selectedStage={progressor.selectedStage}
            mode={progressor.mode}
            progressContract={progressor.progressContract}
            canProgressContract={progressor.canProgressContract}
            isReinitialiseOnly={progressor.isReinitialiseOnly}
            isPending={progressor.isPending}
            isSaveDisabled={progressor.isSaveDisabled}
            resultingCampaignStageLabel={progressor.resultingCampaignStageLabel}
            resultingContractStageLabel={progressor.resultingContractStageLabel}
            setMode={progressor.setMode}
            setSelectedContractId={progressor.setSelectedContractId}
            setSelectedStage={progressor.setSelectedStage}
            onProgressContractChange={progressor.onProgressContractChange}
            onSave={() => progressor.setShowConfirmation(true)}
          />
        )}
      </AgxSpacer>

      <TaskProgressorConfirmationModal
        isOpen={progressor.showConfirmation}
        setIsOpen={progressor.setShowConfirmation}
        isPending={progressor.isPending}
        campaignLabel={progressor.selectedCampaignLabel}
        contractLabel={progressor.selectedContractLabel}
        modeLabel={progressor.modeLabel}
        targetStageLabel={progressor.targetStageLabel}
        currentCampaignStageLabel={progressor.currentCampaignStageLabel}
        resultingCampaignStageLabel={progressor.resultingCampaignStageLabel}
        currentContractStageLabel={progressor.currentContractStageLabel}
        resultingContractStageLabel={progressor.resultingContractStageLabel}
        onConfirm={() => void progressor.progressTasks()}
      />
    </AgxSpacer>
  );
};

export default TaskProgressor;
